import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  ro: {
    // Header
    companyName: 'PIRIFAN DISTRIBUTION SRL',
    systemName: 'Sistem Gestionare Oferte',
    admin: 'Admin',
    
    // Form titles
    submitOffer: 'Trimite Oferta',
    formDescription: 'Completați formularul de mai jos pentru a trimite oferta dumneavoastră',
    
    // Products section
    offeredProducts: 'Produse Ofertate',
    addProduct: 'Adaugă Produs',
    product: 'Produs',
    category: 'Categorie',
    selectCategory: 'Selectați categoria',
    selectProduct: 'Selectați produsul',
    productSpecifications: 'Specificații Produs',
    describeSpecifications: 'Descrieți specificațiile produsului ofertat...',
    minimumQuantity: 'Cantitate Minimă (MOQ)',
    quantityExample: 'ex: 100 buc',
    price: 'Preț',
    priceExample: 'ex: 50 RON/buc',
    
    // Payment terms
    paymentConditions: 'Condiții Plată',
    paymentTerms: 'Termen Plată',
    paymentTermsExample: 'ex: 30 zile de la livrare',
    
    // Company info
    companyData: 'Date Firmă',
    companyName2: 'Nume Firmă',
    companyNameExample: 'SC EXAMPLE SRL',
    fiscalCode: 'Cod Fiscal',
    fiscalCodeExample: 'RO12345678',
    locality: 'Localitate',
    localityExample: 'București',
    
    // Contact person
    contactPerson: 'Persoană Contact',
    contactName: 'Nume Contact',
    contactNameExample: 'Ion Popescu',
    contactEmail: 'Email Contact',
    contactEmailExample: 'ion.popescu@company.ro',
    contactPhone: 'Telefon Contact',
    contactPhoneExample: '0712345678',
    
    // Buttons
    submitButton: 'Trimite Oferta',
    sending: 'Se trimite...',
    products: 'produs',
    productsPlural: 'produse',
    
    // Messages
    offerSuccess: 'Oferta a fost trimisă cu succes!',
    offerError: 'Eroare la trimiterea ofertei',
    categoryLoadError: 'Eroare la încărcarea categoriilor',
    productLoadError: 'Eroare la încărcarea produselor',
    minOneProduct: 'Trebuie să existe cel puțin un produs',
    
    // Validation
    required: 'Câmpul este obligatoriu',
    minChars: 'Minim {count} caractere',
    invalidEmail: 'Email invalid',
    invalidPhone: 'Telefon invalid',
    selectCategoryFirst: 'Selectați categoria',
    selectProductFirst: 'Selectați produsul',
  },
  en: {
    // Header
    companyName: 'PIRIFAN DISTRIBUTION SRL',
    systemName: 'Offers Management System',
    admin: 'Admin',
    
    // Form titles
    submitOffer: 'Submit Offer',
    formDescription: 'Please fill out the form below to submit your offer',
    
    // Products section
    offeredProducts: 'Offered Products',
    addProduct: 'Add Product',
    product: 'Product',
    category: 'Category',
    selectCategory: 'Select category',
    selectProduct: 'Select product',
    productSpecifications: 'Product Specifications',
    describeSpecifications: 'Describe the specifications of the offered product...',
    minimumQuantity: 'Minimum Quantity (MOQ)',
    quantityExample: 'e.g.: 100 pcs',
    price: 'Price',
    priceExample: 'e.g.: 50 RON/pc',
    
    // Payment terms
    paymentConditions: 'Payment Conditions',
    paymentTerms: 'Payment Terms',
    paymentTermsExample: 'e.g.: 30 days from delivery',
    
    // Company info
    companyData: 'Company Data',
    companyName2: 'Company Name',
    companyNameExample: 'EXAMPLE COMPANY LLC',
    fiscalCode: 'Fiscal Code',
    fiscalCodeExample: 'RO12345678',
    locality: 'Locality',
    localityExample: 'Bucharest',
    
    // Contact person
    contactPerson: 'Contact Person',
    contactName: 'Contact Name',
    contactNameExample: 'John Doe',
    contactEmail: 'Contact Email',
    contactEmailExample: 'john.doe@company.com',
    contactPhone: 'Contact Phone',
    contactPhoneExample: '0712345678',
    
    // Buttons
    submitButton: 'Submit Offer',
    sending: 'Sending...',
    products: 'product',
    productsPlural: 'products',
    
    // Messages
    offerSuccess: 'Offer submitted successfully!',
    offerError: 'Error submitting offer',
    categoryLoadError: 'Error loading categories',
    productLoadError: 'Error loading products',
    minOneProduct: 'There must be at least one product',
    
    // Validation
    required: 'Field is required',
    minChars: 'Minimum {count} characters',
    invalidEmail: 'Invalid email',
    invalidPhone: 'Invalid phone',
    selectCategoryFirst: 'Select category',
    selectProductFirst: 'Select product',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'ro';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'ro' ? 'en' : 'ro');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};